<template lang="html">
  <!-- Header -->
  <header id="page-header">
    <!-- Header Content -->
    <div class="content-header">
      <!-- Left Section -->
      <div>
        <!-- Toggle Sidebar -->
        <!-- Layout API, functionality initialized in Template._uiApiLayout()-->
        <button type="button" class="btn btn-dual mr-1" data-toggle="layout" data-action="sidebar_toggle">
          <i class="fa fa-fw fa-bars"></i>
        </button>
        <!-- END Toggle Sidebar -->

        <!-- Open Search Section -->
        <!-- Layout API, functionality initialized in Template._uiApiLayout() -->
        <button type="button" class="btn btn-dual" data-toggle="layout" data-action="header_search_on">
          <i class="fa fa-fw fa-search"></i> <span class="ml-1 d-none d-sm-inline-block">Search</span>
        </button>
        <!-- END Open Search Section -->
      </div>
      <!-- END Left Section -->

      <!-- Right Section -->
      <div>
        <!-- User Dropdown -->
        <div class="dropdown d-inline-block">
          <button type="button" class="btn btn-dual" id="page-header-user-dropdown" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-fw fa-user d-sm-none"></i>
            <span class="d-none d-sm-inline-block">{{ fullname }}</span>
            <i class="fa fa-fw fa-angle-down ml-1 d-none d-sm-inline-block"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-right p-0" aria-labelledby="page-header-user-dropdown">
            <div class="p-2">
              <a class="dropdown-item" @click="logout" href="#">
                <i class="far fa-fw fa-arrow-alt-circle-left mr-1"></i> Sign Out
              </a>
            </div>
          </div>
        </div>
        <!-- END User Dropdown -->
      </div>
      <!-- END Right Section -->
    </div>
    <!-- END Header Content -->

    <!-- Header Search -->
    <div id="page-header-search" class="overlay-header bg-primary">
      <div class="content-header">
        <form class="w-100" action="be_pages_generic_search.html" method="post">
          <div class="input-group">
            <div class="input-group-prepend">
              <!-- Layout API, functionality initialized in Template._uiApiLayout() -->
              <button type="button" class="btn btn-primary" data-toggle="layout" data-action="header_search_off">
                <i class="fa fa-fw fa-times-circle"></i>
              </button>
            </div>
            <input type="text" class="form-control border-0" placeholder="Search or hit ESC.."
                   id="page-header-search-input" name="page-header-search-input">
          </div>
        </form>
      </div>
    </div>
    <!-- END Header Search -->

    <!-- Header Loader -->
    <!-- Please check out the Loaders page under Components category to see examples of showing/hiding it -->
    <div id="page-header-loader" class="overlay-header bg-primary-darker">
      <div class="content-header">
        <div class="w-100 text-center">
          <i class="fa fa-fw fa-2x fa-sun fa-spin text-white"></i>
        </div>
      </div>
    </div>
    <!-- END Header Loader -->
  </header>
  <!-- END Header -->
</template>

<script>
  import { mapGetters } from 'vuex'
  // import store from '@/store'
  export default {
    computed: {
      ...mapGetters({
        fullname: 'user/fullname'
      })
    },
    data() {
      return {
        name: 'Administrator'
      }
    },
    methods: {
      signout() {
        this.$store.dispatch('user/signout')
        this.$router.push({ path: '/user/signin' })
      },
      logout() {
        this.$store.dispatch('user/logout')
        this.$router.push({ path: '/user/signin' })
      }
    }
  }
</script>

<style lang="css">
</style>
